import {toggleMark} from "tiptap-commands/src";
import { Mark } from 'tiptap';

export default class TextColorExtension extends Mark {
    get name() {
        return "color";
    }

    get schema() {
        return {
            attrs: {
                color: {
                    default: "black"
                },

            },
            parseDOM: [
                {
                    style: "color",
                    getAttrs: value => ({
                        color: value,
                    })
                }
            ],
            toDOM: mark => ["span",
                {style: `color: ${mark.attrs.color};`
            }, 0]
        };
    }

    commands({ type }) {
        return attrs => toggleMark(type, attrs);
    }

}